import { combineReducers } from 'redux'
import { journeyReducer } from './journey-reducer'

export const JourneyReducer = combineReducers({
  journey: journeyReducer,
})